/**
 * The store detail tabs, in display order.
 *
 * Order and labels intentionally mirror the mobile bottom navigation
 * (see MOBILE_NAV_ITEMS in components/Layout.tsx) so the two surfaces read the
 * same. Snooze Items leads because it's the most frequently used action.
 *
 * Tab position doubles as the `currentTab` index AND maps to the
 * `/stores/:storeId/:function` route segment, so both StoreDetailView and
 * StoreRouter derive their indexes from this single list rather than
 * hard-coding numbers that can drift apart.
 */
export type StoreFunction = 'items' | 'channels' | 'store-hours' | 'activity';

export const STORE_DETAIL_TABS: ReadonlyArray<{ fn: StoreFunction; label: string }> = [
  { fn: 'items', label: 'Snooze Items' },
  { fn: 'channels', label: 'Channels' },
  { fn: 'store-hours', label: 'Hours' },
  { fn: 'activity', label: 'Activity' },
];

export const STORE_FUNCTIONS: StoreFunction[] = STORE_DETAIL_TABS.map((t) => t.fn);

/** The tab shown when the URL carries no function segment. */
export const DEFAULT_STORE_FUNCTION: StoreFunction = STORE_DETAIL_TABS[0].fn;

export function tabIndexForFunction(fn: StoreFunction): number {
  const index = STORE_DETAIL_TABS.findIndex((t) => t.fn === fn);
  return index === -1 ? 0 : index;
}

export function functionForTabIndex(index: number): StoreFunction {
  return STORE_DETAIL_TABS[index]?.fn ?? DEFAULT_STORE_FUNCTION;
}
